// Adds a "pick any color" swatch to the bottom of Quill's text-color dropdown.
// Quill's default palette only exposes the preset swatches; this lets the user
// choose any hex value through the native OS color picker (the same kind of
// input used for the Close Button / Background color fields). The chosen color
// is applied to the current text selection and stored inline in the message
// HTML (<span style="color:…">), so it renders anywhere the announcement is
// shown without any backend or consuming-app changes.
//
// Returns a cleanup function that removes the swatch and its listeners.
export function enableCustomColorPicker(quill) {
  const toolbar = quill.getModule('toolbar')?.container
  if (!toolbar) return () => {}

  const options = toolbar.querySelector('.ql-color .ql-picker-options')
  // Bail if the picker isn't there yet or the swatch is already injected.
  if (!options || options.querySelector('.ql-custom-color')) return () => {}

  // Remember the last real selection. Opening the dropdown and the native OS
  // color picker both blur the editor, so getSelection() would be null by the
  // time the color is chosen — we colour this saved range instead.
  let lastRange = quill.getSelection()
  const handleSelection = (range) => {
    if (range) lastRange = range
  }
  quill.on('selection-change', handleSelection)

  const wrapper = document.createElement('label')
  wrapper.className = 'ql-custom-color'
  wrapper.title = 'Custom color'

  const input = document.createElement('input')
  input.type = 'color'
  wrapper.appendChild(input)

  const applyColor = () => {
    const range = lastRange || quill.getSelection()
    if (!range) return
    if (range.length > 0) {
      // Colour the selected text. Source 'user' makes react-quill fire its
      // onChange so the controlled value stays in sync.
      quill.formatText(range.index, range.length, 'color', input.value, 'user')
    } else {
      // No selection: set the cursor format so the next typed text is coloured.
      quill.setSelection(range, 'silent')
      quill.format('color', input.value, 'user')
    }
  }
  // 'change' fires once when the color is committed (not on every drag step).
  input.addEventListener('change', applyColor)

  options.appendChild(wrapper)

  return () => {
    quill.off('selection-change', handleSelection)
    input.removeEventListener('change', applyColor)
    wrapper.remove()
  }
}
